
<template>
<div id="app" >
  <v-app style="background: #003333;">
    <div class="breadcrumbs">
        <button class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);" @click="$store.state.showTimeline = true; $store.state.showProfile = false" aria-label="Go to main timeline">
            <img v-bind:src="require(`@/assets/ui/icon_breadcrumb_home.png`)" id="home-icon">
            <p>Timeline Home</p>
        </button>
        <button class="breadcrumb-current breadcrumb-btn">
            <p style="color: black"><span>{{ person }}</span></p>
        </button>
    </div>
    <button @click="downloadProfile()" id="mobile-download"><img class="printer" v-bind:src="require(`@/assets/ui/icon_download.png`)" alt="Printer icon" v-bind:aria-label="`Save/print ${person}'s profile`" :tabindex="0"></button>
    <button onclick="window.print();return false;" id="desktop-print"><img class="printer" v-bind:src="require(`@/assets/ui/icon_print.png`)" alt="Printer icon" v-bind:aria-label="`Save/print ${person}'s profile`" :tabindex="0"></button>
    <div id="profile-page" class="row">
      <div class="column" id="profile-basic" style="text-align: center">
          <img class="profile-large" v-bind:src="require(`@/assets/art/icon-photos/${ getFileName(this.person) }.png`)" v-bind:alt="`Profile photo of ${person}`">
          <h2 id="heading"> {{ person }} </h2>
          <hr class="rounded">
          <p class="profile-date" id="date1"><span style="color: #cc9933;"> Born: </span> {{ profileData.birth }}</p>
          <p class="profile-date" id="date2"><span style="color: #cc9933;"> Died: </span> {{ profileData.death}} </p>
      </div>
      <div class="column" id="profile-details">
          <v-card 
            id="profile-text"
            shaped class="rounded-xl" 
            flat
            elevation="0"
            :style="cardStyle"
          >
            <v-card-text>
              <div id="text"></div>
            </v-card-text>
          </v-card>
         
          <v-card shaped class="rounded-xl" max-width="100%"
            flat
            elevation="0"
            :style="cardStyle"
          >
            <v-card-text>
              <p><span style="color: #cc9933">Associates: </span></p>
              <div v-if="this.profileData.associates" :style="associateIcons">
                <div v-for="(n, i) in associateImgs.length" :key="i">
                  <button @click="loadNewProfile(associates[i])"><img class="profile-icon" v-bind:src="require(`@/assets/art/icon-photos/${associateImgs[i]}.png`)" style="max-width: 4rem; max-height: 4rem" v-bind:alt="`Photo of ${associates[i]}`" v-bind:aria-label="`Go to ${associates[i]}'s profile page`" /></button>
              </div>
            </div>
            </v-card-text>
          </v-card>
    </div>
  </div>
  </v-app>
</div>
</template>

<script>
  import data from '@/content/profiles.js'
  import html2PDF from 'jspdf-html2canvas';

  export default {
    name: 'Profile',

    props: ['person'],

    computed: {
    },

    methods: {
      getProfileData(){
        this.profileData = data.profiles.find(item => item.name === this.person);

        if(this.profileData.associates)
        {
          this.associates = this.profileData.associates;
          var preformatted = this.profileData.associates;
          this.associateImgs = [];
          for(let i = 0; i < preformatted.length; i++)
          {
            this.associateImgs.push(this.getFileName(preformatted[i]));
          }
        }

        this.description = this.addLineSpacing(this.profileData.description);
        document.getElementById('text').innerHTML="<p>" + this.description + "</p>";        
      },
      getFileName(name){
        var icon = name;
        var iconFixed = icon.replace(/\s+/g, '-').toLowerCase();
        return iconFixed;
      },
      loadNewProfile(newPerson){
        this.$emit('updatePerson', newPerson);
        window.scrollTo(0,1000);
        window.scrollTo(0,0);
      },
      addLineSpacing(str){
        return str.replaceAll(('\n'), ('<br><br>'));
      },
      downloadProfile() {
        document.getElementById('heading').style.color = 'black';
        document.getElementById('date1').style.color = 'black';
        document.getElementById('date2').style.color = 'black';

        const page = document.getElementById('profile-page');
        html2PDF(page, {
          jsPDF: {
            format: 'a4',
          },
          imageType: 'image/jpeg',
          output: './pdf/profile.pdf'
        });

        document.getElementById('heading').style.color = 'white';
        document.getElementById('date1').style.color = 'white';
        document.getElementById('date2').style.color = 'white';
      },
      mobileStyle(){
        var basic = document.getElementById('profile-basic');
        var details = document.getElementById('profile-details');
        var page = document.getElementById('profile-page');

        if(document.documentElement.clientWidth <= "1024")
        {
          basic.classList.remove('column');
          details.classList.remove('column');
          page.classList.remove('row');
        }
      }
    },

    watch: {
      person: function(){
        this.getProfileData();
      }
    },

    mounted: function () {
      this.getProfileData();

      window.scrollTo(0,1000);
      window.scrollTo(0,0);
      this.mobileStyle();
    },

    created () {
    },

    data() {
      return{
        screens: data.screens,
        profiles: data.profiles,
        profileData: {},
        description: "",
        associates: [],
        associateImgs: [],
        cardStyle: { background: '#0c3d3d', margin: '20px', border: '5px solid #705d31'},
        associateIcons: { display: 'flex' }
      }
    }
  }
</script>

<style lang="css">
    @import "../assets/styles/profile-style.css";
</style>